/**
 * Versions shown in the doc site. Data files are always served from the real version, e.g. /api/4.0.2/openapi.json.
 * - `docSlug` is the version segment used in doc site page URLs, when it differs from the real version
 * - `apiSlug` is the version segment used in calculator API request URLs, when it differs from the real version
 */
export const VERSIONS: { value: string; label: string; docSlug?: string; apiSlug?: string }[] = [
  { value: '4.0.2', label: 'v4.0 beta', docSlug: '4.0-beta', apiSlug: '4.0-beta' },
  // 4.0.1 is the last version that will have a monolithic openapi file
  { value: '3.0.2', label: 'v3.0.2' },
  { value: '3.0.0', label: 'v3.0.0' },
  { value: '2.0.0', label: 'v2.0.0' },
  { value: '1.3.0', label: 'v1.3.0' },
  { value: '1.2.0', label: 'v1.2.0' },
  { value: '1.1.0', label: 'v1.1.0' },
];

/** The doc site URL segment for a version, e.g. 4.0.2 -> 4.0-beta */
export function docSlug(version: string): string {
  return VERSIONS.find((v) => v.value === version)?.docSlug ?? version;
}

/** The calculator API URL segment for a version, e.g. 4.0.2 -> 4.0-beta in /calculator/4.0-beta/beef */
export function apiSlug(version: string): string {
  return VERSIONS.find((v) => v.value === version)?.apiSlug ?? version;
}

/** The real version for a doc site URL segment, e.g. 4.0-beta -> 4.0.2. Unknown segments are returned unchanged. */
export function versionFromDocSlug(slug: string | undefined): string | undefined {
  if (!slug) return slug;
  return VERSIONS.find((v) => (v.docSlug ?? v.value) === slug)?.value ?? slug;
}

/** The display name for a version without the leading "v", e.g. 4.0.2 -> 4.0 beta */
export function versionDisplayName(version: string | undefined): string | undefined {
  if (!version) return version;
  return VERSIONS.find((v) => v.value === version)?.label.replace(/^v/, '') ?? version;
}
